import axios from "axios";
//export const BASE_URL = "https://localhost:7141";
//export const BASE_URL = "http://192.168.1.17:5080";
export const BASE_URL = "https://backend.optimajobs.in";

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosAuth = axios.create({
  baseURL: BASE_URL,
  headers: { ContentType: "application/json" },
  withCredentials: true,
});
